import { ReactNode, MouseEventHandler, CSSProperties } from 'react';

interface CardNBProps {
  variant?: 'default' | 'interactive';
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler;
  style?: CSSProperties;
}

export default function CardNB({
  variant = 'default',
  children,
  className = '',
  onClick,
  style,
}: CardNBProps) {
  const baseStyles = `
    bg-nb-white
    border-3 border-nb-black
    p-6
    rounded-[2px]
  `.replace(/\s+/g, ' ').trim();

  const interactiveStyles = variant === 'interactive'
    ? 'cursor-pointer hover:-translate-y-1 hover:border-4 transition-transform duration-200'
    : '';

  return (
    <div
      className={`${baseStyles} ${interactiveStyles} ${className}`.trim()}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
}
